import React from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const comparisonTable = [{
  sit: 'Lanzás tu primera campaña',
  sin: 'Gastás plata aprendiendo de errores evitables',
  con: 'La Auditoría Zero Error elimina los errores antes de encender el presupuesto'
}, {
  sit: 'Tu LP no convierte',
  sin: 'No sabés qué cambiar primero',
  con: 'Los Blueprints de LP te dicen exactamente qué optimizar'
}, {
  sit: 'Querés escalar el presupuesto',
  sin: 'Lo subís de golpe y el CPA se dispara',
  con: 'El Método Cama de Presupuesto escala sin que el algoritmo entre en shock'
}, {
  sit: 'Meta te rechaza un anuncio',
  sin: 'No sabés por qué ni cómo resolverlo',
  con: 'El Workflow de Contingencia te dice exactamente qué hacer'
}, {
  sit: 'Querés gestionar desde el celular',
  sin: 'Revisás el dashboard cada hora sin sistema',
  con: 'El Tablero de Comando te da los 5 números en 15 minutos'
}, {
  sit: 'Alguien copia tu anuncio',
  sin: 'No sabés cómo responder estratégicamente',
  con: 'El Protocolo de Competencia te da el plan de diferenciación'
}];
const acceleratorFeatures = ['Auditoría de Pre-Lanzamiento de 100 puntos', 'Protocolo de Muerte Súbita (detectar fallos en 2 horas)', 'Blueprints de Landing Pages para tickets hasta $100.000 ARS', 'Los 7 Patrones de Interrupción Visual que Meta no penaliza', 'Sistema IA-Shadow para atender WhatsApp automáticamente', 'Tablero de Comando CEO en tiempo real desde el celular', 'El Método Cama de Presupuesto para escalar sin perder ROAS', 'Workflows de contingencia para las 7 crisis más comunes'];
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-71">
      <div className="max-w-6xl mx-auto px-4" data-id="element-72">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16" data-id="element-73">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 text-red-500 font-bold text-sm mb-8 border border-red-500/20" data-id="element-74">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-75" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <CountdownTimer data-id="element-76" />

          <p className="text-lg md:text-xl text-gray-300 mt-8 mb-6" data-id="element-77">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-neutral-900 border border-neutral-800 rounded-xl p-4" data-id="element-78">
            <div className="text-sm font-bold text-red-500 flex items-center gap-2 mb-2" data-id="element-79">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-80" />
              Cupos al precio de lanzamiento — Quedan pocos
            </div>
            <div className="w-full bg-neutral-800 rounded-full h-3 overflow-hidden mb-1" data-id="element-81">
              <div className="bg-gradient-to-r from-red-600 to-red-500 h-3 rounded-full" style={{
              width: '72%'
            }} data-id="element-82" />
            </div>
            <div className="text-xs text-gray-500 text-right" data-id="element-83">
              72% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-10 md:mb-16" data-id="element-84">
          ELEGÍ TU KIT
        </h2>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-20 md:mb-24" data-id="element-85">
          {/* Card 1 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-86">
            <div className="text-4xl mb-4" data-id="element-87">📘</div>
            <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-88">
              KIT MÁQUINA DE VENTAS™
            </h3>
            <p className="text-[#D4AF37] font-medium mb-5 text-sm md:text-base" data-id="element-89">
              6 Tomos + 6 Guías de Acción
            </p>
            <div className="bg-neutral-800/50 rounded-xl p-4 mb-6" data-id="element-90">
              <span className="text-gray-500 text-xs block mb-1" data-id="element-91">
                Ideal para:
              </span>
              <span className="text-white font-medium text-sm" data-id="element-92">
                Emprendedores digitales que quieren construir su primer ingreso
                online con el sistema completo
              </span>
            </div>
            <div className="mb-6" data-id="element-93">
              <div className="text-gray-500 line-through text-lg" data-id="element-94">$146.000</div>
              <div className="text-4xl md:text-5xl font-bold text-white" data-id="element-95">
                $24.990{' '}
                <span className="text-xl font-medium text-gray-400" data-id="element-96">ARS</span>
              </div>
            </div>
            <a href="https://www.nexorecursos.com/cart/52508914876692:1" className="w-full py-4 rounded-xl bg-neutral-800 hover:bg-neutral-700 text-white font-bold text-base md:text-lg transition-colors mt-auto border border-neutral-700 text-center block" data-id="element-97">
              → QUIERO MI KIT AHORA
            </a>
          </div>

          {/* Card 2 - Highlighted */}
          <div className="bg-gradient-to-b from-neutral-800 to-neutral-900 border-2 border-[#D4AF37] rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col relative" style={{
          boxShadow: '0 0 60px -15px rgba(212,175,55,0.35)'
        }} data-id="element-98">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-b from-[#E5C158] to-[#D4AF37] text-black font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wide" data-id="element-99">
              MÁS ELEGIDO
            </div>
            <div className="text-4xl mb-4" data-id="element-100">🏆</div>
            <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-101">
              KIT MÁQUINA DE VENTAS™ + ACELERADOR 10X ⭐
            </h3>
            <p className="text-[#D4AF37] font-medium mb-5 text-sm md:text-base" data-id="element-102">
              6 Tomos + 6 Guías + Sistema Acelerador 10X
            </p>
            <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-xl p-4 mb-6" data-id="element-103">
              <span className="text-[#D4AF37]/90 text-xs block mb-1" data-id="element-104">
                Ideal para:
              </span>
              <span className="text-white font-medium text-sm" data-id="element-105">
                Emprendedores que quieren además la infraestructura técnica de
                agencia para escalar sin errores que quemen el presupuesto
              </span>
            </div>
            <div className="mb-6" data-id="element-106">
              <div className="text-gray-500 line-through text-lg" data-id="element-107">$195.000</div>
              <div className="text-4xl md:text-5xl font-bold text-white" data-id="element-108">
                $32.990{' '}
                <span className="text-xl font-medium text-gray-400" data-id="element-109">ARS</span>
              </div>
            </div>
            <a href="https://www.nexorecursos.com/cart/52508916187412:1" className="animate-pulse-glow w-full py-4 rounded-xl bg-gradient-to-b from-[#E5C158] to-[#D4AF37] hover:from-[#F0CF6E] hover:to-[#E5C158] text-black font-bold text-base md:text-lg transition-all active:scale-95 mt-auto text-center block" data-id="element-110">
              → QUIERO EL KIT + ACELERADOR 10X
            </a>
          </div>
        </div>

        {/* Accelerator Comparison */}
        <div className="max-w-5xl mx-auto" data-id="element-111">
          <h3 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-112">
            🕊️ ¿QUÉ AGREGA EL SISTEMA ACELERADOR 10X?
          </h3>

          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-12" data-id="element-113">
            <div className="overflow-x-auto" data-id="element-114">
              <table className="w-full text-left min-w-[700px]" data-id="element-115">
                <thead data-id="element-116">
                  <tr className="bg-neutral-800/60" data-id="element-117">
                    <th className="p-4 md:p-6 text-gray-300 font-semibold text-sm border-b border-neutral-700 w-1/3" data-id="element-118">
                      Tu situación
                    </th>
                    <th className="p-4 md:p-6 text-red-400 font-semibold text-sm border-b border-neutral-700 w-1/3" data-id="element-119">
                      ❌ Sin Acelerador 10X
                    </th>
                    <th className="p-4 md:p-6 text-[#D4AF37] font-semibold text-sm border-b border-neutral-700 w-1/3" data-id="element-120">
                      ✅ Con Acelerador 10X
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-121">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-neutral-800/50 hover:bg-neutral-800/20 transition-colors" data-id="element-122">
                      <td className="p-4 md:p-6 text-white font-medium text-sm" data-id="element-123">
                        {row.sit}
                      </td>
                      <td className="p-4 md:p-6 text-gray-400 text-sm" data-id="element-124">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-[#E5C158] font-medium text-sm" data-id="element-125">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-126">
            <h4 className="text-xl md:text-2xl font-bold text-white mb-6 md:mb-8 text-center" data-id="element-127">
              ✅ EL ACELERADOR 10X INCLUYE:
            </h4>
            <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-128">
              {acceleratorFeatures.map((f, i) => <div key={i} className="flex items-start gap-3" data-id="element-129">
                  <span className="text-[#D4AF37] mt-0.5 shrink-0" data-id="element-130">✅</span>
                  <span className="text-gray-300 font-medium text-sm md:text-base" data-id="element-131">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}